/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-01-08 11:25:54
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-10-30 15:11:17
 * @FilePath: \h5-lcjc-formula\src\utils\category\RI.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 风湿免疫学 */

/** 对应的标题 */
const categoryMap = {
  GoutClassificationCriteria: 'ACR/EULAR痛风诊断标准',
  AcrEular: 'ACR/EULAR类风湿关节炎分类标准和评分系统',
  IAIHG: '自身免疫性肝炎的综合诊断积分系统',
  CCFRA: '类风湿关节炎分类标准（ACR）',
  AIHSDC: 'AIH简化诊断积分',
  SLA: '系统性红斑狼疮分类标准（ACR）',
  BehcetDisease: '白塞综合征（BS）诊断',
  Classificationcriteriaforfunctionalstatusofrheumatoidarthritisjoints: '类风湿关节炎关节功能状态分级标准',
  Boolean2criteria: '类风湿关节炎临床缓解标准',
  ClassificationcriteriaofrheumatoidarthritisbyXrays: '类风湿关节炎X线分类标准',
  DiagnosticCriteriaofAnkylosingspondylitis: '强直性脊柱炎诊断标准',
  DiagnosticCriteriaofOsteoarthritisofhands: '手关节骨关节炎临床诊断标准',
  DiagnosticCriteriaofOsteoarthritisofknees: '膝关节骨关节炎临床诊断标准',
  TheYamaguchiDiagnosticCriteriaofAdultonsetStill: '成人still病的Yamaguchi诊断标准',
  Lupus_nephritis: '狼疮性肾炎分型(ISN/RPS,2003)',
  STAR: '干燥综合征STAR应答指数',
  SSDAI: '干燥综合征疾病活动指数（SSDAI）',
  Complement_Component_three:'补体因子3（C3）',
  Complement_Component_four:'补体因子4（C4）',
  Anti_Cyclic_Citrullinated_Peptide_Antibodies:'抗环瓜氨酸肽抗体（Anti-CCP）',
  UA: '尿酸',
  Monocytes: '单核细胞',
  Absolute_Monocyte_Count: '绝对单核细胞计数',
  Eosinophil: '嗜酸性粒细胞',
  Immunoglobulin_G: '免疫球蛋白G（IgG）',
  Immunoglobulin_M: '免疫球蛋白M（IgM）',
  Antithyroid_peroxidase_antibody: '甲状腺过氧化物酶抗体（Anti-TPO）'
}
/** 对应的描述 */
const categoryDescMap = {
  GoutClassificationCriteria: '',
  AcrEular: 'ACR/EULAR类风湿关节炎分类标准和评分系统',
  IAIHG: '1999年IAIHG制定',
  CCFRA: '美国风湿病学会修订',
  AIHSDC: '自身免疫性肝炎简化诊断标准',
  SLA: '1997年美国风湿病学会制定',
  BehcetDisease: '国际分类标准',
  Classificationcriteriaforfunctionalstatusofrheumatoidarthritisjoints: '评估并判断患者的关节功能和疗效',
  Boolean2criteria: '评估类风湿关节炎是否达到临床缓解',
  ClassificationcriteriaofrheumatoidarthritisbyXrays: '通过X线评估类风湿关节炎（RA）的分期'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/RI.js